import api from "./api";
import { v4 as uuid } from "uuid";
import { TConversation } from "../models/conversation";
import type { TAttachment } from "@atlas/tool/box/file/types";
import getAuthHeaders from "./get-auth-headers";

export type TCreateConversationPayload = {
  formId?: string;
  key: string;
  attachments: TAttachment[];
  copiedCustomers: string[];
  fields: Record<string, unknown>;
};

export default function createConversation(
  appId: string,
  payload: TCreateConversationPayload
) {
  return api<TConversation>({
    path: "/customer-portal/conversations",
    method: "POST",
    headers: getAuthHeaders(appId),
    body: { ...payload, fingerprintId: uuid() },
  });
}
